var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkydebaneanlaeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2,7.824l.167,3.806a.683.683,0,0,0,.683.653h2.11a.683.683,0,0,0,.683-.668l.05-2.4,1.13.49.106.043.235.021L7.469,9.7,9.985,7.571l.064-.554,1.14-.057a.284.284,0,0,0,.221-.12l.2-.271,2.539-.038a.29.29,0,0,0,.286-.3l-.011-.3-.036-.008A.28.28,0,0,0,14.114,6l-.057.058-.043.063-.021.064H8.429V5.866H9.908a.292.292,0,0,0,.29-.291V5.516a.291.291,0,0,0-.29-.29H6.4a.29.29,0,0,0-.29.29v.059a.291.291,0,0,0,.29.291h.712v.319H5.828l-.064.064L5.359,6.7c-.7.012-1.417,0-2.092.035A.981.981,0,0,0,2.2,7.824Zm1.84-4.3a1.4,1.4,0,1,1-1.4,1.4,1.4,1.4,0,0,1,1.4-1.4ZM7.277,8.147,6.19,7.7l.085-.064.086-.064L6.4,7.486l.022-.064.042-.085.022-.064L8.535,7.1Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkydebaneanlaeg);
export default __webpack_public_path__ + "static/media/SKYDEBANEANLAEG.3ef6ea6c8071bcff15368b40d055988f.svg";
export { ForwardRef as ReactComponent };